import { get, post } from '@/utils/request'
/* 登录 */
export const login = data => post('/login/loginOrRegister', data)
/* 获取验证码 */
export const getCode = data => get('/login/sendVar', data)
/* 微信授权 */
export const wxLogin = data => post('/login/wechatLogin', data)

/* 获取公众号二维码 */
export const getOfficialAccount = data => post('/login/generateCode', data)
/* 当前二维码是否已扫 */
export const hasItBeenScanned = data => get('/user/hasItBeenScanned', data)
/* 公众号登录 */
export const AccountLogin = data => post('/login/officialAccountLogin', data)
/* 绑定手机 */
export const bindingPhone = data => post('/login/bindMobileNumber', data)
/* 手机号登录 */
export const loginByPhone = data => post('/login/loginByPhone', data)

/* 公众号授权登录 */
export const authorization = data => post('/login/officialAccountAuthorization', data)
/* 公众号授权登录 */
export const appOfficialAccountAuthorization = data => post('/login/appOfficialAccountAuthorization', data)

export const getEvaluateInfo = id => get(`/login/getEvaluateInfo/${id}`)

/* 公众号授权登录 */
export const saveEvaluateInfo = data => post('/login/saveEvaluateInfo', data)

/** 登出 */
export const logout = () => post('/login/logout')

/** 查询token是否失效 */
export const checkToken = () => get('/login/verifyToken')



// WEBPACK FOOTER //
// ./src/api/login.js